// Financial Reporting suite — the due-date strip on the shared
// AttentionStrip: one chip per severity (overdue / due within 30 days /
// upcoming), items listing each active series' next reporting deadline.

import {
  AttentionStrip,
  type AttentionChip,
} from "@/components/portfolioAdmin/loanDetail/common/AttentionStrip";
import type { ReportingDueItemDto } from "@/api/portfolioAdmin/financialReportingApi";
import { periodLabelForCode } from "./reportingFormat";

export function ReportingDueStrip({
  items,
  testId,
}: {
  items: ReportingDueItemDto[];
  testId?: string;
}) {
  const toItems = (status: ReportingDueItemDto["status"]) =>
    items
      .filter((i) => i.status === status)
      .map((i) => ({
        id: `${i.seriesCode}-${i.periodEnd}`,
        title: `${i.seriesCode} ${i.seriesTitle} — ${periodLabelForCode(i.seriesCode, i.periodEnd)}`,
        date: i.dueDate,
      }));

  const overdue = toItems("overdue");
  const due = toItems("due");
  const upcoming = toItems("upcoming");
  const chips: AttentionChip[] = [
    { id: "overdue", label: "Overdue", count: overdue.length, tone: "error", items: overdue },
    { id: "due", label: "Due within 30 days", count: due.length, tone: "warning", items: due },
    { id: "upcoming", label: "Upcoming", count: upcoming.length, tone: "neutral", items: upcoming },
  ];

  return <AttentionStrip chips={chips} testId={testId} />;
}
